import {
  CREATE_EXPLORE_REQUEST,
  CREATE_EXPLORE_SUCCESS,
  CREATE_EXPLORE_FAILED,
  GET_EXPLORE_REQUEST,
  GET_EXPLORE_SUCCESS,
  GET_EXPLORE_FAILED,
  UPDATE_EXPLORE_REQUEST,
  UPDATE_EXPLORE_SUCCESS,
  UPDATE_EXPLORE_FAILED,
  CLEAR_EXPLORE_SUCCESS,
  PUBLISHED_EXPLORE_STATUS_FAILED,
  PUBLISHED_EXPLORE_STATUS_REQUEST,
  PUBLISHED_EXPLORE_STATUS_SUCCESS,
  SEARCH_EXPLORE_REQUEST,
  SEARCH_EXPLORE_SUCCESS,
  SEARCH_EXPLORE_FAILED,
  GET_EXPLORE_CATEGORY_REQUEST,
  GET_EXPLORE_CATEGORY_SUCCESS,
  GET_EXPLORE_CATEGORY_FAILED,
  CREATE_EXPLORE_CATEGORY_REQUEST,
  CREATE_EXPLORE_CATEGORY_SUCCESS,
  CREATE_EXPLORE_CATEGORY_FAILED,
  UPDATE_EXPLORE_CATEGORY_REQUEST,
  UPDATE_EXPLORE_CATEGORY_SUCCESS,
  UPDATE_EXPLORE_CATEGORY_FAILED,
  DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST,
  DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS,
  DRAFT_EXPLORE_ACTIVE_STATUS_FAILED,
  ACTIVE_EXPLORE_CATEGORY_REQUEST,
  ACTIVE_EXPLORE_CATEGORY_SUCCESS,
  ACTIVE_EXPLORE_CATEGORY_FAILED,
  REMOVE_EXPLORE_SUCCESS,
  REMOVE_EXPLORE_FAILED,
  REMOVE_EXPLORE_REQUEST,
  REMOVE_CATEGORY_REQUEST,
  REMOVE_CATEGORY_FAILED,
  REMOVE_CATEGORY_SUCCESS,
  CLEAR_EXPLORE_DATA,
  PREVIEW_EXPLORE_SUCCESS,

  COPY_CONTENT_FAILED,
  COPY_CONTENT_SUCCESS,
  COPY_CONTENT_REQUEST,
  REORDER_CONTENT_SUCCESS,
  REORDER_CONTENT_FAILED,
  REORDER_CONTENT_REQUEST,
} from "../Actions/ExploreAction";

const ExploreInitialState = {
  loading: false,
  updateLoading: false,
  success: false,
  errors: {},
  usersPerPage: 10,
  currentPage: 1,
  totalCount: 0,
  isEdit: false,
  exploreList: [],
  categories: [],
  exploreDetail: [],
  exploreCategoryList: [],
  copy_status: false,
  allExploreCategoryList: [],
};

export const ExploreReducer = (state = ExploreInitialState, action) => {
  switch (action.type) {
    case COPY_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        copy_status: false,
      };
    case COPY_CONTENT_FAILED:
      return {
        ...state,
        loading: false,
        copy_status: false,
      };
    case COPY_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        copy_status: true,
        // exploreList: [], //add copied data here
      };
    case REORDER_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case REORDER_CONTENT_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case REORDER_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case CREATE_EXPLORE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case CREATE_EXPLORE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case CREATE_EXPLORE_FAILED:
      return {
        ...state,
        success: false,
        loading: false,
      };

    case PREVIEW_EXPLORE_SUCCESS:
      return {
        ...state,
        exploreDetail: action?.payload,
      };

    case GET_EXPLORE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPLORE_SUCCESS:
      return {
        ...state,
        loading: false,
        exploreDetail: action?.payload,
        isEdit: true,
        totalCount: action?.payload?.count,
      };

    case GET_EXPLORE_FAILED:
      return {
        ...state,
        loading: false,
      };

    case CLEAR_EXPLORE_SUCCESS: {
      return {
        ...state,
        loading: false,
        exploreDetail: [],
        totalCount: 0,
        isEdit: false,
      };
    }

    case UPDATE_EXPLORE_REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
      };

    case UPDATE_EXPLORE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        exploreDetail: action?.payload,
        totalCount: action?.payload?.total,
        isEdit: false,
      };

    case UPDATE_EXPLORE_FAILED:
      return {
        ...state,
        success: false,
        loading: false,
      };
    case PUBLISHED_EXPLORE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PUBLISHED_EXPLORE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        exploreList: state?.exploreList?.filter(
          (item) => item?.Id !== action?.payload?.Id
        ),
        totalCount: action?.payload?.count,
      };
    case PUBLISHED_EXPLORE_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_EXPLORE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_EXPLORE_SUCCESS:
      return {
        ...state,
        exploreList: action?.payload?.explore_list,
        categories: action?.payload?.categories,
        totalCount: action?.payload?.count,
        loading: false,
      };
    case SEARCH_EXPLORE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case GET_EXPLORE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPLORE_CATEGORY_SUCCESS:
      return {
        ...state,
        exploreCategoryList: action?.payload?.category_list,
        totalCount: action?.payload?.total,
        loading: false,
      };
    case GET_EXPLORE_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
      };
   
    case CREATE_EXPLORE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_EXPLORE_CATEGORY_SUCCESS:
      return {
        ...state,
        exploreCategoryList: [...state.exploreCategoryList, action.payload],
        loading: false,
      };
    case CREATE_EXPLORE_CATEGORY_FAILED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EXPLORE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EXPLORE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        exploreCategoryList: state?.exploreCategoryList?.map((item, index) =>
          item?.id === action?.payload?.id ? action?.payload : item
        ),
      };
    case UPDATE_EXPLORE_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
      };
    case DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        exploreList: state?.exploreList?.map((item) =>
          item?.Id === action?.payload?.Id ? action?.payload : item
        ),
      };
    case DRAFT_EXPLORE_ACTIVE_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case ACTIVE_EXPLORE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIVE_EXPLORE_CATEGORY_SUCCESS:
      return {
        ...state,
        exploreCategoryList: action?.payload,
        loading: false,
      };
    case ACTIVE_EXPLORE_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REMOVE_EXPLORE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_EXPLORE_SUCCESS:
      return {
        ...state,
        exploreList: state?.exploreList?.filter(
          (item) => item?.Id !== action?.payload
        ),
        loading: false,
      };
    case REMOVE_EXPLORE_FAILED:
      return {
        ...state,
        loading: false,
      };

    case REMOVE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_CATEGORY_SUCCESS:
      return {
        ...state,
        exploreCategoryList: state?.exploreCategoryList?.filter(
          (item) => item?.id !== action?.payload
        ),
        loading: false,
      };
    case REMOVE_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_EXPLORE_DATA:
      return {
        ...state,
        loading: false,
        success: false,
        copy_status: false,
      };
    default:
      return state;
  }
};
